<template>
  <div>
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter">
        <!-- <img src="@/assets/img/appointment/back.svg" /> -->
      </div>
      <div class="nav-title d-allcenter overflow">校外人员场馆预约</div>
      <div class="nav-right d-allcenter" style="font-size: 12px" @click="editClick">{{ rightText }}</div>
    </div>
    <div class="content">
      <div class="each d-between d-aligncnter">
        <div>人脸</div>
        <div class="photo">
          <!-- <img :src="userInfo.headImg" /> -->
          <el-avatar :size="32" :src="userInfo.headImg" @error="errorHandler">
            <img src="@/assets/img/appointment/headimg.svg" />
          </el-avatar>
        </div>
      </div>
      <div class="each d-between d-aligncnter">
        <div>姓名</div>
        <div class="grey" v-if="rightText == '编辑'">{{ userInfo.name }}</div>
        <div v-else><el-input v-model="userInfo.name" placeholder="请输入姓名"></el-input></div>
      </div>
      <div class="each d-between d-aligncnter">
        <div>手机号</div>
        <div class="grey" v-if="rightText == '编辑'">{{ userInfo.mobile }}</div>
        <div v-else><el-input v-model="userInfo.mobile" placeholder="请输入手机号"></el-input></div>
      </div>

      <div class="each d-between d-aligncnter mt-16" @click="pageToFpset">
        <div>发票设置</div>
        <div class="grey">
          <img
            src="@/assets/img/appointment/backgrey.svg"
            class="transform-180"
            style="width: 16px; height: 16px; margin-left: 8px"
          />
        </div>
      </div>

      <div class="each d-between d-aligncnter mt-16" @click="pageToFriend">
        <div>伙伴管理</div>
        <div class="grey">
          <img
            src="@/assets/img/appointment/backgrey.svg"
            class="transform-180"
            style="width: 16px; height: 16px; margin-left: 8px"
          />
        </div>
      </div>
    </div>
    <div class="d-allcenter">
      <!-- <button class="save-btn">保&nbsp;&nbsp;&nbsp;&nbsp;存</button> -->
    </div>
  </div>
</template>
<script>
import { getUser, edit } from '@/api/api-venueOrder'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      phone: '',
      userInfo: { headImg: '', name: '', mobile: '' },
      rightText: '编辑',
    }
  },
  mounted() {
    this.getInfoData()
    this.$on('getInfoData', function () {
      this.getInfoData()
    })
  },
  methods: {
    getInfoData() {
      const userId = localStorage.getItem('userId')
      getUser(userId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getUser:', res)
          this.userInfo = res.data.obj
        }
      })
    },
    editClick() {
      const userId = localStorage.getItem('userId')
      if (this.rightText == '编辑') {
        this.rightText = '保存'
      } else {
        edit(userId, this.userInfo.name, this.userInfo.mobile).then((res) => {
          if (res.data.statusCode == 1) {
            this.rightText = '编辑'
            this.getInfoData()
            Message.success('已保存')
          } else {
            Message.error(res.data.message)
          }
        })
      }
    },
    pageToFriend() {
      this.$router.push('/appointment/friendmanage')
    },
    pageToFpset() {
      this.$router.push('/appointment/invoiceset')
    },
    errorHandler() {
      return true
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';

.mt-16 {
  margin-top: 16px;
}
.content {
  padding: 0;
}
.each {
  background: #f9f9f9;
  box-shadow: 0px -1px 0px 0px #e8e8e8 inset;
  padding: 8px 16px;
  min-height: 32px;
  color: #181818;
}
.photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d4a3fc;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.save-btn {
  border-radius: 52px;
  background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  width: 343px;
  height: 56px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin-top: 16px;
  //   position: absolute;
  //   bottom: 152px;
}
</style>
